var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"location"},[_c('div',[_vm._v("当前只支持移动端定位，可使用操作栏移动端按钮预览体验")])])
}]

export { render, staticRenderFns }